import { Toolbar } from "primereact/toolbar";
import { ILogin, IPermissionProps } from "../../models/Login";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import React, { useEffect, useRef, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { IModal } from "./AllocationList";
import { EmptyAllHisFilter, Filter, IAllHisFilter } from "./Filter";
import { Accordion, AccordionTab } from "primereact/accordion";
import { format } from "date-fns";
import { Button } from "primereact/button";
import { safeFormatDate } from "../../models/DateFormatMapper";


interface IAllocationHistory {
    req_ID?: number,
    recruiter_ID?: number,
    recruiter_Person_Name?: string,
    allocated_By_Name?: string,
    allocate_by?: number,
    createdOn?: Date,
}


interface Iprops {
    setModal: (modal: IModal) => void,
    toast: any,
    reload: boolean,
    permissions: IPermissionProps,
    setReload: (is: boolean) => void,
}

export const Table = (props: Iprops) => {

    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IAllocationHistory>, loading: boolean });
    const [allHisFilter, setAllHisFilter] = useState<IAllHisFilter>(EmptyAllHisFilter);

    const dt = useRef<any>(null);



    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Allocation List</h5>
        </div>
    );


    // const loadTableData = async ()=>{
    //     setTableData({ tableData: tableData.tableData, loading: true });
    //     const response = await Fetch("AllocateRequirement_mast/allocationlistingHistory", "GET", null, `filter=${JSON.stringify(allHisFilter)}`, props.toast);
    //     if(response){
    //         const data = await response.json();
    //         setTableData({ tableData: data, loading: false });
    //     }else{
    //         setTableData({ tableData: tableData.tableData, loading: false });
    //     }
    // }

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("AllocateRequirement_mast/allocationlistingHistory", "GET", null, `filter=${JSON.stringify(allHisFilter)}`, props.toast);

        if (response) {
            const data: Array<IAllocationHistory> = await response.json();
            setTableData({ tableData: data, loading: false });
        }
    }


    const exportCSV = () => {
        dt.current.exportCSV();
    };


    const created_At = (rowData: IAllocationHistory) => {
        let date;
        if (rowData.createdOn) date = format(new Date(rowData.createdOn), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const rightToolbarTemplate = () => {
        return (
            props.permissions.is_Export ?
                <React.Fragment>
                    <Button label="Export" icon="pi pi-upload" className="p-button-help" onClick={exportCSV} />
                </React.Fragment> : ''
        );
    };


    useEffect(() => {
        loadTableData();
    }, [allHisFilter]);

    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    const DateFormat = loginObj?.date_Format;
    return (
        <>
            <Toolbar className="mb-1 py-0" right={rightToolbarTemplate} ></Toolbar>
            <Accordion>
                <AccordionTab header="Filter">
                    <Filter allHisFilter={allHisFilter} setAllHisFilter={setAllHisFilter} />
                </AccordionTab>
            </Accordion>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                ref={dt} size="small" stripedRows showGridlines scrollable scrollHeight="65vh" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                value={tableData.tableData}
                header={header}
                loading={tableData.loading}
            >
                <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />

                <Column field="req_ID" header="Req ID" />
                <Column field="recruiter_Person_Name" header="Recruiter" />
                {/* <Column field="createdOn" header="Created At" body={created_At} /> */}
                <Column field="createdOn" header="Created At" body={(rowData: any) => safeFormatDate(rowData.createdOn, "dd/MM/yyyy", DateFormat)} />
                <Column field="allocated_By_Name" header="Allocated By" body={(rowData) => <span style={{ color: rowData.allocated_By_Name == null ? 'green' : 'red' }}>{rowData.allocated_By_Name == null ? "Auto Allocated" : rowData.allocated_By_Name}</span>} />
            </DataTable>
        </>
    );
}